import requestWrapper from "../utils/requestWrapper";
import { IGenericResponse } from "@/services/interfaces";
import { ICartPayload } from "@/services/interfaces/requests";

export default async (params: ICartPayload): Promise<IGenericResponse> => {
  const request = {
    url: "/api/cart/products",
    method: "POST",
    data: params,
  };

  return await requestWrapper(request);
};
